<script lang="ts">
    export let loadAllShuttles
    export let lastUpdate
    export let lang

    function showUpdatedTime() {
      if (lang === "en") {
      return `Updated ${lastUpdate} ${lastUpdate === 1 ? "minute" : "minutes"} ago`
      } else {
        return `Mis à jour il y a ${lastUpdate} minute${lastUpdate === 1 ? "" : "s"}`
      }
    }
</script>  
  <div class="bb-1 b-grey-300 bg-white">
      <div class="d-flex flx-jspace txt-nodecoration p-2 py-sm-1">
        <div class="">{showUpdatedTime()}</div>
        <a href="#" class="d-flex flx-acenter" on:click={() => { loadAllShuttles()} }>
          <div class="h-20 mr-1">
            <img
            src="images/refresh.svg"
            loading="lazy"
            alt=""
            class="h-full obj-contain obj-l"
            />
          </div>
          <div class="txt-size-500 txt-semibold txt-npblue-500">{lang === "en" ? "Refresh" : "Actualiser"}</div>
        </a>
    </div>
  </div>
  